import { service } from '../axios';
export function createSupplier(data) {
    return service({ url: '/cons/suppliers/save', method: 'post', data });
}
